module.exports = __webpack_public_path__ + "static/img/exploit15.1993de6f.png";